import React from 'react';
import { useTranslation } from 'react-i18next';
import BaseDataGlance from './baseGlances/baseDataGlance'



export default function Taxes(props) {

    const { t } = useTranslation();
    return (
        <>
            <BaseDataGlance cssContentClass='taxes-glance-body'
                cssHeadingClass='taxes-glance-heading'
                cssIconClass='icons8-tax'
                Heading={t('Taxes')}
                DataPoint1={props.DP1}
                DataPoint3={'<div>' + props.DP2 + ' ' + t('Tax') + ' 1</br>' + props.DP3 + ' ' + t('Tax') + ' 2</div>'}
            ></BaseDataGlance>
        </>
    );
}